import i18next from 'i18next'
import { initReactI18next } from 'react-i18next'

let enTranslation = require('./locale/en.json')
let nbTranslation = require('./locale/nb.json')
let deTranslation = require('./locale/de.json')
let nnTranslation = require('./locale/nn.json')
let seTranslation = require('./locale/sv_SE.json')
let customTranslation = require('./locale/custom_1.json')

export const LANG = 'language'
export const DEFAULT_LANG = 'nb'

export const getLang = () => {
    const selectedLang = localStorage.getItem(LANG)
    if (selectedLang) {
        return selectedLang
    }
    const isEnglishDomain = document.location.hostname === 'inspection.cubitfire.com'
    if (isEnglishDomain) {
        return 'en'
    }
    return DEFAULT_LANG
}

export const initTranslation = async () => {
    // let isEnglishDomain = document.location.hostname === 'inspection.cubitfire.com'
    await i18next
        //.use(LazyImportPlugin)
        .use(initReactI18next)
        .init({
            // lng: isEnglishDomain ? 'en' : 'nb',
            resources: {
                en: {
                    translation: enTranslation,
                },
                nb: {
                    translation: nbTranslation,
                },
                de: {
                    translation: deTranslation,
                },
                nn: {
                    translation: nnTranslation,
                },
                se: {
                    translation: seTranslation,
                },
                custom_1: {
                    translation: customTranslation,
                },
            },
            supportedLngs: ['nb', 'en', 'de', 'nn', 'se', 'custom_1'],
            contextSeparator: '*',
            pluralSeparator: '%%',
            nsSeparator: '::',
        })

    const current_language = getLang()
    await i18next.changeLanguage(current_language)
}
